import React, { useState, useEffect, useRef } from "react";
import { Redirect, Route, Link, useLocation } from "react-router-dom";
import auth from "services/auth";
import { gameTitles, gameTypeIcons } from "configs/gameTypes";
import api from "services/api";
// import emailValidate from "services/emailValidate";
import GameItem from "elements/gameElements/GameItem";
import Translator, { __ } from "services/Translator";
import { Button } from "react-bootstrap";
import Slider from "react-slick";
import GameMenu from "elements/gameElements/GameMenu";
//New structured import
import { AngleRight, AngleLeft } from "components/Icons";
export default function GameSlider(props) {
  // const menuOpen = props.menuOpen;
  const location = useLocation();
  const [categoryName, setCategoryName] = useState(props.categoryName);
  const [isAuthenticated, setIsAuthenticated] = useState(auth.isAuthenticated);
  const [gameListsData, setGameListsData] = useState([]);
  const [popularSlots, setPopularSlots] = useState([]);
  const [tableGames, setTableGames] = useState([]);
  const category = props.category;
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(props.perPage);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPrevDisabled, setIsPrevDisabled] = useState(true);
  const [isNextDisabled, setIsNextDisabled] = useState(false);
  const specificGamesKey = JSON.stringify(props.specificGames ?? []);
  const prevCategoryRef = useRef(category);
  const prevSpecificGamesKeyRef = useRef(specificGamesKey);

  const getGames = async () => {
    var response = await api.post("/games/by-category", {
      per_page: perPage,
      page: page,
      game_types: [category],
      specific_games: props.specificGames,
    });

    if (response.status === 200 && response.data) {
      const newGames = response.data.games[category]?.gamelist ?? [];
      setGameListsData((prev) =>
        page === 1 ? newGames : prev.concat(newGames)
      );

      // if (category == "video_slots") {
      //   const tempGameList = gameListsData;
      //   var mergedGameList = tempGameList.concat(response.data.games.video_slots.gamelist);
      //   setGameListsData(mergedGameList);
      // } else if (category == "table_games") {
      //   const tempGameList = gameListsData;
      //   var mergedGameList = tempGameList.concat(response.data.games.table_games.gamelist);
      //   setGameListsData(mergedGameList);
      // } else if (category == "video_poker") {
      //   const tempGameList = gameListsData;
      //   var mergedGameList = tempGameList.concat(response.data.games.video_poker.gamelist);
      //   setGameListsData(mergedGameList);
      // } else if (category == "live_casino") {
      //   const tempGameList = gameListsData;
      //   var mergedGameList = tempGameList.concat(response.data.games.live_casino.gamelist);
      //   setGameListsData(mergedGameList);
      // } else if (category == "new") {
      //   const tempGameList = gameListsData;
      //   var mergedGameList = tempGameList.concat(response.data.games.new.gamelist);

      //   setGameListsData(mergedGameList);
      // } else if (category == "popular") {
      //   const tempGameList = gameListsData;
      //   var mergedGameList = tempGameList.concat(response.data.games.popular.gamelist);
      //   setGameListsData(mergedGameList);
      // } else if (category == "jackpot") {
      //   const tempGameList = gameListsData;
      //   var mergedGameList = tempGameList.concat(response.data.games.jackpot.gamelist);
      //   setGameListsData(mergedGameList);
      // }
    }
  };

  // Reset list and page only when category or specificGames content changes
  useEffect(() => {
    if (!category) return;

    const categoryChanged = prevCategoryRef.current !== category;
    const specificGamesChanged =
      prevSpecificGamesKeyRef.current !== specificGamesKey;

    if (categoryChanged || specificGamesChanged) {
      setGameListsData([]);
      setPage(1);
      prevCategoryRef.current = category;
      prevSpecificGamesKeyRef.current = specificGamesKey;
    }
  }, [category, specificGamesKey]);

  useEffect(() => {
    if (category) {
      getGames();
    }
  }, [category, page, perPage, specificGamesKey]);

  // Function to get current slidesToShow based on screen width
  const getCurrentSlidesToShow = () => {
    const width = window.innerWidth;
    if (width >= 1400) return 10; // Large screens
    if (width >= 992) return 8;   // Medium screens
    if (width >= 768) return 6;   // Small screens
    return 3; // Mobile
  };

  useEffect(() => {
    // Initialize disabled states when game data changes
    if (gameListsData.length > 0) {
      setIsPrevDisabled(true); // Start at the beginning
      const slidesToShow = getCurrentSlidesToShow();
      setIsNextDisabled(gameListsData.length <= slidesToShow); // Disable next if not enough items
    }
  }, [gameListsData]);

  // Add window resize listener to update disabled states on screen size change
  useEffect(() => {
    const handleResize = () => {
      if (gameListsData.length > 0) {
        const slidesToShow = getCurrentSlidesToShow();
        const maxSlide = Math.max(0, gameListsData.length - slidesToShow);
        setIsNextDisabled(currentSlide >= maxSlide);
        setIsPrevDisabled(currentSlide === 0);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [gameListsData.length, currentSlide]);

  const loadMoreGamesAction = (prm) => {
    setPage((prev) => prev + 1);
    setPerPage(24);
  };

  // games settings
  const gameNextLoad = () => {
    if (!isNextDisabled) {
      sliderRef.current.slickNext();
    }
  };

  const gamePrevLoad = () => {
    if (!isPrevDisabled) {
      sliderRef.current.slickPrev();
    }
  };

  const handleBeforeChange = (oldIndex, newIndex) => {
    setCurrentSlide(newIndex);
  };

  const handleAfterChange = (current) => {
    setCurrentSlide(current);

    // Check if we're at the beginning
    setIsPrevDisabled(current === 0);

    // Check if we're at the end
    const totalSlides = gameListsData.length;
    const slidesToShow = getCurrentSlidesToShow();

    // Calculate the maximum slide position
    const maxSlide = Math.max(0, totalSlides - slidesToShow);
    setIsNextDisabled(current >= maxSlide);
  };

  // Ensure we don't try to show more slides than we have games
  const getAdjustedSlidesToShow = (defaultSlides) => {
    return Math.min(defaultSlides, gameListsData.length || 1);
  };

  const gamesSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: getAdjustedSlidesToShow(10),
    slidesToScroll: getAdjustedSlidesToShow(10),
    autoplay: false,
    autoplaySpeed: 5000,
    initialSlide: 0,
    arrows: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: getAdjustedSlidesToShow(8),
          slidesToScroll: getAdjustedSlidesToShow(8),
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: getAdjustedSlidesToShow(6),
          slidesToScroll: getAdjustedSlidesToShow(6),
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: getAdjustedSlidesToShow(3),
          slidesToScroll: getAdjustedSlidesToShow(3),
          infinite: false,
          dots: true,
        },
      },
    ],
  };

  const sliderRef = useRef();
  return (
    <section className="gameSlider">
      <div className=" game_container padding_top_bottom_30">
        <div className="gameSliderHeading">
          {/* <div className="headline_text">{props.categoryName}</div> */}
          <div className="gameAction">
            {props.title == true && (
              <div className="headline_text">
                {gameTypeIcons[props.category] ?? ""}
                {props.categoryLabel}
                {/* {gameTitles[props.category] ?? ""} */}
              </div>
            )}

            {props.menuBar != false && (
              <GameMenu callFromSlider={true} {...props} />
            )}



            <div className="slideAction">
              <Link
                hreflang={Translator.getSelectedLanguage().code}
                to={"/games/" + props.category}
                className=" commonBtn pTwoBtn"
              >
                {__("View All")}
              </Link>
              <Button
                onClick={gamePrevLoad}
                className={`action_btn ${isPrevDisabled ? "disabled" : ""}`}
                disabled={isPrevDisabled}
              >
                <AngleLeft
                  width="12"
                  height="12"
                  fillColor={isPrevDisabled ? "#ccc" : "#4b486e"}
                />
              </Button>
              <Button
                onClick={gameNextLoad}
                className={`action_btn ${isNextDisabled ? "disabled" : ""}`}
                disabled={isNextDisabled}
              >
                <AngleRight
                  width="12"
                  height="12"
                  fillColor={isNextDisabled ? "#ccc" : "#4b486e"}
                />
              </Button>
            </div>
          </div>
        </div>

        {gameListsData.length > 0 ? (
          <Slider
            ref={sliderRef}
            {...gamesSettings}
            beforeChange={handleBeforeChange}
            afterChange={handleAfterChange}
          >
            {gameListsData.map(
              (game, index, arr) => {
                const isLast = index === arr.length - 1;
                if (isLast) {
                  return (
                    <div className={"gameItemBlock "} key={"see-more"}>
                      <Link
                        hreflang={Translator.getSelectedLanguage().code}
                        to={"/games/" + props.category}
                        className="game_thumb see_more"
                      >
                        <div className="game_overlay always_visible">
                          <h3 className="game_name">{__("See All")}</h3>
                        </div>
                      </Link>
                    </div>
                  );
                }
                return (
                  <GameItem
                    key={game?.id ?? index}
                    game={game}
                    isAuthenticated={props.isAuthenticated}
                  />
                );
              }
            )}
          </Slider>
        ) : (
          <div style={{ padding: '20px', textAlign: 'center', color: 'white' }}>
            <p>Loading games...</p>
          </div>
        )}
      </div>
    </section>
  );
}
